// MT-11B.8 — READ-ONLY correction queue: doctor-led per-Rx corrections grouped by
// source record, for future administrator-approved purification. No actions.
import { useEffect, useState } from "react";
import api from "../lib/api";
import { ListChecks } from "lucide-react";

const SOURCE_LABEL = { mylist: "My List", olddb: "Old DB", search_group: "Search group", free_text: "Free text" };

export function CorrectionQueue() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/medicines/correction-queue").then((r) => setData(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Could not load"));
  }, []);
  return (
    <div className="space-y-3" data-testid="correction-queue">
      <div className="text-xs bg-sky-50 border border-sky-200 rounded-md p-3 text-sky-900 flex items-start gap-2">
        <ListChecks size={14} className="mt-0.5 shrink-0" />
        <div><strong>Read-only.</strong> Every time a doctor corrects a medicine <em>for one prescription</em> (or resolves a combined search group into one product), the original and corrected values are recorded on that Rx. This queue groups those records by source so an administrator can later approve a database purification. Nothing here changes My List or Old DB.</div>
      </div>
      {err && <div className="text-xs text-rose-700" data-testid="correction-queue-error">{err}</div>}
      <div className="bg-white border border-slate-200 rounded-md overflow-x-auto">
        <table className="w-full text-xs min-w-[900px]">
          <thead className="bg-slate-50">
            <tr className="text-left text-[10px] uppercase tracking-wider text-slate-500">
              <th className="p-3">Source</th><th className="p-3 min-w-[240px]">Source record / group</th><th className="p-3 w-16">Count</th>
              <th className="p-3 min-w-[260px]">Most frequent corrected values</th><th className="p-3">First · last seen</th><th className="p-3">Sample Rx</th>
            </tr>
          </thead>
          <tbody>
            {!data && !err && <tr><td colSpan={6} className="p-6 text-center text-slate-500">Loading…</td></tr>}
            {data && data.groups.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-slate-500" data-testid="correction-queue-empty">No per-prescription corrections recorded yet.</td></tr>}
            {data?.groups.map((g) => (
              <tr key={`${g.source_type}:${g.source_id}`} className="border-t border-slate-100 align-top" data-testid={`correction-group-${g.source_type}`}>
                <td className="p-3"><span className="px-1.5 py-0.5 rounded bg-slate-100 text-slate-700 font-semibold">{SOURCE_LABEL[g.source_type] || g.source_type}</span></td>
                <td className="p-3"><div className="font-medium text-slate-900">{g.source_label}</div><div className="text-[10px] text-slate-500 font-mono">{g.source_id}</div></td>
                <td className="p-3 tabular font-semibold">{g.count}</td>
                <td className="p-3">{Object.entries(g.most_frequent_corrected || {}).map(([k, v]) => <div key={k}><span className="text-slate-500">{k}:</span> {String(v)}</div>)}</td>
                <td className="p-3 text-[10px] text-slate-600">{(g.first_seen || "").slice(0, 10)} · {(g.last_seen || "").slice(0, 10)}</td>
                <td className="p-3 text-[10px] font-mono text-slate-600">{(g.sample_rx_ids || []).join(", ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
